import { LocationFilterData } from 'component/Search/Location/types';

import { City, CityList } from 'proto/City';
import { RegionList } from 'proto/Region';

export function buildLocationFilterData(
    cityList: CityList | undefined,
    regionList: RegionList | undefined
): LocationFilterData {
    if (!cityList?.itemOrder.length) {
        return {};
    }

    const mappedCityList = cityList.itemOrder.map((id) => cityList.items[id]);
    if (!regionList?.itemOrder.length) {
        return {
            cityList: mappedCityList,
        };
    }

    const cityRegionMap = mappedCityList.reduce(
        (map, city) =>
            map.set(city.regionId, [...(map.get(city.regionId) ?? []), city]),
        new Map<number, City[]>()
    );

    return {
        cityList: mappedCityList,
        regionList: regionList.itemOrder.map((id) => {
            const region = regionList.items[id];

            return {
                ...region,
                cityList: cityRegionMap.get(id) ?? [],
            };
        }),
    };
}
